<template>
  <div class="search-content">
    <div class="site-title">Bootstrap样式 &amp; 光年新增通用样式搜索工具</div>
    <div class="search-type">
      <a href="#!" :class="{ active: bversion == 3 }" @click="chooseVersion(3)">
        Bootstrap 3.7.3
      </a>
      |
      <a href="#!" :class="{ active: bversion == 4 }" @click="chooseVersion(4)">
        Bootstrap 4.4.1
      </a>
    </div>
    <div class="search-box">
      <input
        type="text"
        name="keywords"
        v-model="keywords"
        class="search-input"
        @keyup.enter="searchResult"
      />
    </div>
    <div class="preloader" v-show="loadingStatus">
      <div class="spinner-dots">
        <span class="dot1"></span>
        <span class="dot2"></span>
        <span class="dot3"></span>
      </div>
    </div>
    <ul class="result-ul" v-if="!!result.length">
      <li v-for="(item, index) in result" :key="index">
        <div class="in-li">
          <div v-html="item.content"></div>
        </div>
      </li>
    </ul>
    <div class="no-result" v-else>
      <span>未找到你搜索的关键词。</span>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "ClassSearch",
  data() {
    return {
      keywords: "",
      bversion: 3,
      result: [],
      loadingStatus: false,
    };
  },
  methods: {
    chooseVersion(bver) {
      this.bversion = bver;
      this.result = [];
      this.keywords && this.searchResult();
    },
    searchResult() {
      const that = this;
      this.loadingStatus = true;
      axios
        .get("./json/bs" + this.bversion + ".json")
        .then((response) => {
          this.loadingStatus = false;
          if (that.keywords) {
            that.result = response.data.filter(function (item) {
              if (item.content.toString().indexOf(that.keywords) != -1) {
                let kw = "";
                if (that.keywords.indexOf(".") != -1) {
                  kw = that.keywords.replace(
                    new RegExp(that.keywords, "g"),
                    "\\" + that.keywords
                  );
                } else {
                  kw = that.keywords;
                }
                item.content = item.content.toString().replace(/\r\n/g, "<br>");
                item.content = item.content
                  .toString()
                  .replace(new RegExp(/( )/g), "&nbsp;");
                item.content = item.content
                  .toString()
                  .replace(
                    new RegExp(kw, "g"),
                    "<span class='text-red'>" + that.keywords + "</span>"
                  );
                return item;
              }
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
*,
::after,
::before {
  box-sizing: border-box;
}
.site-title {
  margin-top: 20px;
  text-align: center;
  font-size: 16px;
}
.search-type {
  text-align: center;
  margin: 20px auto;
  a {
    color: #666;
    text-decoration: none;
  }
  a.active {
    color: #33cabb;
  }
}
.search-box {
  margin: 20px auto;
  max-width: 420px;
}
.search-input {
  width: 100%;
}
.search-input {
  width: 100%;
  border: 1px solid #ececec;
  height: 36px;
  line-height: 20px;
  padding: 8px 10px;
  -webkit-transition: border-color ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  &:focus {
    outline: none;
    border-color: #33cabb;
    box-shadow: 0 0 0 0.2rem rgba(51, 202, 187, 0.25);
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(51, 202, 187, 0.6);
    box-shadow: inset 0 1px 1px rgba(248, 194, 194, 0.075),
      0 0 8px rgba(51, 202, 187, 0.6);
  }
}
.result-ul {
  list-style: none;
  padding: 0px;
  li {
    position: relative;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    margin-bottom: 20px;
    .in-li {
      display: block;
      font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
        "Courier New", monospace;
      padding: 15px;
      border: 1px solid #f5f6f7;
      color: #2f6f9f;
      background-color: #fcfdfe;
      ::v-deep .text-red {
        color: #f96868;
      }
    }
    @media (min-width: 900px) {
      display: inline-block;
      width: 100%;
    }
    @media (min-width: 1080px) {
      display: inline-block;
      width: 100%;
    }
  }
  @media (min-width: 900px) {
    -webkit-column-count: 2;
    -moz-column-count: 2;
    column-count: 2;
    -webkit-column-gap: 1.25rem;
    -moz-column-gap: 1.25rem;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
  }
  @media (min-width: 1080px) {
    -webkit-column-count: 3;
    -moz-column-count: 3;
    column-count: 3;
    -webkit-column-gap: 1.25rem;
    -moz-column-gap: 1.25rem;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
  }
}
.preloader {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  display: -webkit-box;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  z-index: 2000;
  .spinner-dots {
    width: 70px;
    text-align: center;
    span {
      width: 12px;
      height: 12px;
      background-color: #33cabb;
      border-radius: 100%;
      display: inline-block;
      -webkit-animation: spinner-dots 1.4s infinite ease-in-out both;
      animation: spinner-dots 1.4s infinite ease-in-out both;
    }
    .dot1 {
      -webkit-animation-delay: -0.32s;
      animation-delay: -0.32s;
    }
    .dot2 {
      -webkit-animation-delay: -0.16s;
      animation-delay: -0.16s;
    }
  }
}
@-webkit-keyframes spinner-dots {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
@keyframes spinner-dots {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
</style>
